import { render, staticRenderFns } from "./Presentation.vue?vue&type=template&id=33faf24a&scoped=true"
import script from "./Presentation.vue?vue&type=script&lang=js"
export * from "./Presentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33faf24a",
  null
  
)

export default component.exports